import React from "react";
import AppearanceCommon from "@/features/settings/AppearanceCommon.jsx";

export default function Appearance() {
  return <AppearanceCommon role="patient" />;
}
